import { environment } from "environments/environment";

export namespace EndpointDictionary {
  const _BASE = {
    BASE_URL_V2: environment.endpoint + '/api/v2/',
    _BASE_URL_V2: environment.endpoint + '/api/v2',
  }

  export const Base = _BASE

  export const Area = {
    CRUD_AREA_DATA: _BASE.BASE_URL_V2 + 'areas', //GET DEL PUT POST
    AREA_TABLE: _BASE.BASE_URL_V2 + 'areas/table', //GET
    AREA_COMBO: _BASE.BASE_URL_V2 + 'areas/combo', //GET
  }

  export const Docs = {
    CRUD_DOCS_DATA: _BASE.BASE_URL_V2 + 'docs', //GET DEL
    DOCS_SUBIR: _BASE.BASE_URL_V2 + 'docs/upload', //PUT  POST
  }

  export const Login = {
    LOGIN_DATA: _BASE.BASE_URL_V2 + 'auth/login', //POST
    LOGOUT: _BASE.BASE_URL_V2 + 'auth/logout', //POST
    GET_USER_PROFILE: _BASE.BASE_URL_V2 + 'auth/getUserProfile', //POST
    VALIDATE_USER: _BASE.BASE_URL_V2 + 'auth/validate-user', //POST
    COMPANY_IS_ACTIVE: _BASE.BASE_URL_V2 + 'auth/company/active', //GET
  }

  export const Company = {
    CRUD_COMPANY_DATA: _BASE.BASE_URL_V2 + 'company', // DEL GETDetalle PUT POST
    COMPANY_COMBO: _BASE.BASE_URL_V2 + 'company/combo', //GET
    COMPANY_TABLE: _BASE.BASE_URL_V2 + 'company/table', //GET
  }

  export const Logs = {
    CRUD_LOGS_DATA: _BASE.BASE_URL_V2 + 'logs', //GET DEL
    LOGS_TABLE: _BASE.BASE_URL_V2 + 'logs/table', //GET
    DELETE_LINE_LOG: _BASE.BASE_URL_V2 + 'logs/line', //DEL
  }

  export const ARL = {
    CRUD_ARL_DATA: _BASE.BASE_URL_V2 + 'arl', //POST PUT DEL
    ARL_TABLE: _BASE.BASE_URL_V2 + 'arl/table', //GET
    ARL_COMBO: _BASE.BASE_URL_V2 + 'arl/combo', //GET
  }

  export const Contry = {
    CRUP_COUNTRY_DATA: _BASE.BASE_URL_V2 + 'countries', //DEL  POST PUT
    COUNTRY_COMBO: _BASE.BASE_URL_V2 + 'countries/combo', //GET
    COUNTRY_TABLE: _BASE.BASE_URL_V2 + 'countries/table', //GET
  }

  export const Provider = {
    PROVIDER_TYPE_COMBO: _BASE.BASE_URL_V2 + 'providers/combo/provider', //GET
    CRUD_PROVIDER_DATA: _BASE.BASE_URL_V2 + 'providers', //GETdetail  DEL  POST  PUT
    PROVIDER_COMBO: _BASE.BASE_URL_V2 + 'providers/combo', //GET
    PROVIDER_TABLE: _BASE.BASE_URL_V2 + 'providers/table', //GET
    PROVIDER_COMBO_FUEl: _BASE.BASE_URL_V2 + 'providers/combo/fuel', //GET
  }

  export const ProviderType = {
    PROVIDER_TYPE_COMBO: _BASE.BASE_URL_V2 + 'providerType/combo' //combo
  }

  export const Position = {
    CRUD_POSITION_DATA: _BASE.BASE_URL_V2 + 'JobTitle', // DEL PUT POST
    POSITION_TABLE: _BASE.BASE_URL_V2 + 'JobTitle/table', //GET
    POSITION_COMBO: _BASE.BASE_URL_V2 + 'JobTitle/combo', //GET
  }

  export const EPS = {
    CRUD_EPS_DATA: _BASE.BASE_URL_V2 + 'eps', //POST PUT DEL
    EPS_TABLE: _BASE.BASE_URL_V2 + 'eps/table', //GET
    EPS_COMBO: _BASE.BASE_URL_V2 + 'eps/combo', //GET
  }

  export const EMAIL = {
    CRUD_EMAIL_DATA: _BASE.BASE_URL_V2 + 'sendEmail', //POST 
  }

  export const Region = {
    REGION_TABLE: _BASE.BASE_URL_V2 + 'regions/table',
    REGION_COMBO: _BASE.BASE_URL_V2 + 'regions/combo',
  }

  export const City = {
    CITY_TABLE: _BASE.BASE_URL_V2 + 'cities/table',
    CITY_COMBO: _BASE.BASE_URL_V2 + 'cities/combo',
  }

  export const User = {                           //ok
    CRUD_USER_DATA: _BASE.BASE_URL_V2 + 'users', //GETDetail POST PUT
    USER_TABLE: _BASE.BASE_URL_V2 + 'users/table', //GET
    USER_COMBO: _BASE.BASE_URL_V2 + 'users/combo', //GET
    USER_PASSWORD: _BASE.BASE_URL_V2 + 'users/password', //POST
    ACTIVE_USER: _BASE.BASE_URL_V2 + 'users/activate', //POST
    INACTIVATE_USER: _BASE.BASE_URL_V2 + 'users/inactivate', //POST
    VALIDATE_IF_USER_EXISTS: _BASE.BASE_URL_V2 + 'users/validateIfUserExists', //GET
    VALIDATE_IF_EMAIL_EXISTS: _BASE.BASE_URL_V2 + 'users/validateIfEmailExists', //GET
    USER_TOKEN: _BASE.BASE_URL_V2 + 'userToken', //POST OR PUT
  }

  export const BloodType = {
    BLOOD_TABLE: _BASE.BASE_URL_V2 + 'bloobType/table',
    BLOOD_COMBO: _BASE.BASE_URL_V2 + 'bloobType/combo',
  }

  export const Gender = {
    GENDER_TABLE: _BASE.BASE_URL_V2 + 'gender/table',
    GENDER_COMBO: _BASE.BASE_URL_V2 + 'gender/combo',
  }

  export const Role = {
    ROLE_TABLE: _BASE.BASE_URL_V2 + 'roles/table',
    ROLE_COMBO: _BASE.BASE_URL_V2 + 'roles/combo',
  }

  export const Memorandum = {
    CRUD_MEMORANDUM_DATA: _BASE.BASE_URL_V2 + 'memorandum', //GETDetail POST DEL
    MEMORANDUM_TABLE: _BASE.BASE_URL_V2 + 'memorandum/table', //GET
  }

  export const Permit = {
    CRUD_PERMIT_DATA: _BASE.BASE_URL_V2 + 'permissions', //GETDetail POST DEL
    PERMIT_TABLE: _BASE.BASE_URL_V2 + 'permissions/table', //GET
  }

  export const Disabilities = {
    CRUD_DISABILITIES_DATA: _BASE.BASE_URL_V2 + 'disabilities', //GETDetail POST
    DISABILITIES_TABLE: _BASE.BASE_URL_V2 + 'disabilities/table', //GET
  }

  export const userEntryRecord = {
    CRUD_USER_ENTRY_RECORD: _BASE.BASE_URL_V2 + 'userEntryRecord', //GETDetail POST
    USER_ENTRY_RECORD_TABLE: _BASE.BASE_URL_V2 + 'userEntryRecord/table', //post
    USER_ENTRY_RECORD_EXIT: _BASE.BASE_URL_V2 + 'userEntryRecord/exit', //post
    USER_ENTRY_RECORD_COMBO: _BASE.BASE_URL_V2 + 'userEntryRecord/combo/userRegister', //GET
  }

  export const Activity = {
    CRUD_ACTIVITY_DATA: _BASE.BASE_URL_V2 + 'activities', //GETDetail POST PUT DEL
    ACTIVITY_TABLE: _BASE.BASE_URL_V2 + 'activities/table', //GET
    ACTIVITY_COMBO: _BASE.BASE_URL_V2 + 'activities/combo', //GET
  }

  export const ActivityeEmerg = {
    CRUD_ACTIVITY_EMERG_DATA: _BASE.BASE_URL_V2 + 'emergingActivities', //GETDetail POST PUT DEL
    ACTIVITY_EMERG_TABLE: _BASE.BASE_URL_V2 + 'emergingActivities/table', //GET
    ACTIVITY_EMERG_COMBO: _BASE.BASE_URL_V2 + 'emergingActivities/combo', //GET
  }

  export const ActivityeFrec = {
    CRUD_ACTIVITY_FREC_DATA: _BASE.BASE_URL_V2 + 'frequentActivities', //POST PUT DEL
    ACTIVITY_FREC_TABLE: _BASE.BASE_URL_V2 + 'frequentActivities/table', //GET
    ACTIVITY_FREC_COMBO: _BASE.BASE_URL_V2 + 'frequentActivities/combo', //GET
  }

  export const Notification = {
    CRUD_NOTIFICATION_DATA: _BASE.BASE_URL_V2 + 'notification', //POST  DEL
    NOTIFICATION_COMBO: _BASE.BASE_URL_V2 + 'notification/by-user', //GET
    NOTIFICATION_DELETE: _BASE.BASE_URL_V2 + 'notification/deleteByUrl', //POST
    NOTIFICATIONS_TYPE: _BASE.BASE_URL_V2 + 'notification/notificationType', //GET
  }

  export const Equipment = {
    CRUD_EQUIPMENT_DATA: _BASE.BASE_URL_V2 + 'equipment', //GETDetail POST PUT DEL
    EQUIPMENT_TABLE: _BASE.BASE_URL_V2 + 'equipment/table', //GET
    EQUIPMENT_COMBO: _BASE.BASE_URL_V2 + 'equipment/combo', //GET
    EQUIPMENT_KM: _BASE.BASE_URL_V2 + 'equipment/currentOdometer', //PUT
    EQUIPMENT_DISPO: _BASE.BASE_URL_V2 + 'equipment/availability', //PUT
    INACTIVATE_EQUIPMENT: _BASE.BASE_URL_V2 + 'equipment/inactivate', //PUST
    ACTIVE_EQUIPMENT: _BASE.BASE_URL_V2 + 'equipment/activate', //PUST
    GET_ALL: _BASE.BASE_URL_V2 + 'equipment/getAll', //get
    EQUIPMENT_TABLE_BY_INSPECTION_FORM: _BASE.BASE_URL_V2 + 'equipment/table/equipmentByForm', //GET
    EQUIPMENT_MISSING_BY_FORM_TABLE: _BASE.BASE_URL_V2 + 'equipment/table/missingEquipment', //GET
  }

  export const HistoricalFuel = {
    CRUD_HISTORICAL_FUEL_DATA: _BASE.BASE_URL_V2 + 'historicalFuel', //GETDetail POST PUT DEL
    HISTORICAL_FUEL_TABLE: _BASE.BASE_URL_V2 + 'historicalFuel/table', //GET
    HISTORICAL_FUEL_COMBO: _BASE.BASE_URL_V2 + 'historicalFuel/combo', //GET
    HISTORICAL_FUEL_CLOSE: _BASE.BASE_URL_V2 + 'historicalFuel/close', //PUT close
    PUT_HISTORICAL_FUEL: _BASE.BASE_URL_V2 + 'historicalFuel/close/historical',
    POST_EMAIL: _BASE.BASE_URL_V2 + 'historicalFuel/sendEmail', //POST
  }

  export const ComponentEquipment = {
    CRUD_COMPONENT_EQUIPMENT_DATA: _BASE.BASE_URL_V2 + 'components', //GETDetail POST PUT DEL
    COMPONENT_EQUIPMENT_TABLE: _BASE.BASE_URL_V2 + 'components/table', //GET
  }

  export const OdometerProjection = {
    ODOMETER_PROJECTION_TABLE: _BASE.BASE_URL_V2 + 'projections/odometer/table', //GET
  }

  export const EquipmentType = {
    CRUD_EQUIPMENT_TYPE_DATA: _BASE.BASE_URL_V2 + 'equipmentType', //POST PUT DEL
    EQUIPMENT_TYPE_TABLE: _BASE.BASE_URL_V2 + 'equipmentType/table', //GET
    EQUIPMENT_TYPE_COMBO: _BASE.BASE_URL_V2 + 'equipmentType/combo', //GET
    UPDATE_INFORATION_INSPECTION: _BASE.BASE_URL_V2 + 'equipmentType/inspection'
  }

  export const WorkOrder = {
    WORK_ORDER_RESOURCES_READY: _BASE.BASE_URL_V2 + 'workOrder/readyResources', //PUT
    CRUD_WORK_ORDER_DATA: _BASE.BASE_URL_V2 + 'workOrder', //GETDetail POST PUT DEL
    WORK_ORDER_TABLE: _BASE.BASE_URL_V2 + 'workOrder/table', //GET
    WORK_ORDER_COMBO: _BASE.BASE_URL_V2 + 'workOrder/combo', //GET
    WORK_ORDER_AUTHORIZE: _BASE.BASE_URL_V2 + 'workOrder/authorize', //PUT
    WORK_ORDER_CLOSE: _BASE.BASE_URL_V2 + 'workOrder/closeOrder', //POST
    TYPES_MAINTENANCE: _BASE.BASE_URL_V2 + 'workOrder/maintenanceType', //GET
    WORK_ORDER_COMBO_STATE: _BASE.BASE_URL_V2 + 'workOrder/combo/state', //GET
    POST_EMAIL: _BASE.BASE_URL_V2 + 'workOrder/sendEmail', //POST
    COMMENTS: {
      CRUD_DATA: _BASE.BASE_URL_V2 + 'commentsOrders', //POST DEL
      TABLE: _BASE.BASE_URL_V2 + 'commentsOrders/table', //GET
      COMBO: _BASE.BASE_URL_V2 + 'commentsOrders/combo', //GET
      BY_ORDER: _BASE.BASE_URL_V2 + 'commentsOrders/order', //GET
      TYPES: _BASE.BASE_URL_V2 + 'commentType', //GET
    }

  }

  export const UserOrder = {
    CRUD_USER_ORDER_DATA: _BASE.BASE_URL_V2 + 'usersOrders', //POST DEL
    USER_ORDER_TABLE: _BASE.BASE_URL_V2 + 'usersOrders/table', //GET
  }

  export const Resources = {
    CRUD_RESOURCES_DATA: _BASE.BASE_URL_V2 + 'resources', //POST DEL PUT DETAIL
    RESOURCES_TABLE: _BASE.BASE_URL_V2 + 'resources/table', //GET
    RESOURCES_WAREHOUSE_TABLE: _BASE.BASE_URL_V2 + 'resources/table/warehouse', //GET
  }

  export const ResourcesRequest = {
    CRUD_RESOURCES_REQUEST_DATA: _BASE.BASE_URL_V2 + 'resourcesRequest', //POST DEL PUT DETAIL
    RESOURCES_REQUEST_TABLE: _BASE.BASE_URL_V2 + 'resourcesRequest/table', //GET
    RESOURCES_REQUEST_COMBO: _BASE.BASE_URL_V2 + 'resourcesRequest/combo', //GET combo

  }

  export const ResourcesActivity = {
    CRUD_RESOURCES_ACTIVITY_DATA: _BASE.BASE_URL_V2 + 'resourcesActivity', //POST DEL PUT DETAIL
    RESOURCES_ACTIVITY_TABLE: _BASE.BASE_URL_V2 + 'resourcesActivity/table', //GET
    RESOURCES_ACTIVITY_COMBO: _BASE.BASE_URL_V2 + 'resourcesActivity/combo', //GET combo
  }

  export const historicalWO = {
    CRUD_HISTORICAL_WO_DATA: _BASE.BASE_URL_V2 + 'historicalWorkOrder', //GETDetail PUT DEL
    HISTORICAL_WO_TABLE: _BASE.BASE_URL_V2 + 'historicalWorkOrder/table', //GET
  }

  export const PreopQuestion = {
    CRUD_PREOP_QUESTION_DATA: _BASE.BASE_URL_V2 + 'questions', //POST PUT DEL
    PREOP_BY_FORM: _BASE.BASE_URL_V2 + 'questions/form', //GET
    PREOP_MISSING_BY_FORM: _BASE.BASE_URL_V2 + 'questions/table/missingQuestion', //GET
    ALL_QUESTIONS: _BASE.BASE_URL_V2 + 'questions/allQuestions', //GET
  }

  export const InspectionForm = {
    CRUD_INSPECTION_FORM_DATA: _BASE.BASE_URL_V2 + 'inspectionForm', //POST PUT DEL
    INSPECTION_FORM_TABLE: _BASE.BASE_URL_V2 + 'inspectionForm/table', //GETTABLE
    INSPECTION_FORM_BY_EQUIPMENT_TABLE: _BASE.BASE_URL_V2 + 'inspectionForm/table/byEquipment', //GETTABLE
    INSPECTION_FORM_COMBO: _BASE.BASE_URL_V2 + 'inspectionForm/combo', //GET
    INACTIVATE_INSPECTION_FORM: Base.BASE_URL_V2 + 'inspectionForm/inactivate', //PUT
    ACTIVE_INSPECTION_FORM: Base.BASE_URL_V2 + 'inspectionForm/activate', //PUT    
    GET_CODE: Base.BASE_URL_V2 + 'inspectionForm/getCode', //GET
    COMBO_CODE: _BASE.BASE_URL_V2 + 'inspectionForm/combo/codes', //GET
    COMBO_VERSION: _BASE.BASE_URL_V2 + 'inspectionForm/combo/versions', //GET
  }

  export const QuestionInspectionForm = {
    CRUD_QUESTION_FORM_DATA: _BASE.BASE_URL_V2 + 'questionForm', //POST DEL
    QUESTION_FORM_ORDER: _BASE.BASE_URL_V2 + 'questionForm/order', //PUT
  }

  export const EquipmentInspectionForm = {
    CRUD_EQUIPMENT_INSPECTION_FORM_DATA: _BASE.BASE_URL_V2 + 'equipmentForm', //POST DEL
  }

  export const PeriodicityType = {
    PERIODICITY_TYPE_COMBO: _BASE.BASE_URL_V2 + 'periodicityType/combo' //combo
  }

  export const HistoryPreop = {
    CRUD_HISTORY_PREOP_DATA: _BASE.BASE_URL_V2 + 'historicalInspections', //GETDetail POST PUT DEL
    HISTORY_PREOP_TABLE: _BASE.BASE_URL_V2 + 'historicalInspections/table', //GET
    HAS_INSPECTION_ACTIVE: Base.BASE_URL_V2 + 'historicalInspections/hasInspectionActive',
    INSPECTION_ACTIVE_BY_EQUIPMENT_AND_FORM: Base.BASE_URL_V2 + 'historicalInspections/questionInspectionAutoComplite',
    CLOSE_INSPECTION_HISTORY: Base.BASE_URL_V2 + 'historicalInspections/close', //POST
  }

  export const PreopRHistory = {
    CRUD_PREOP_R_HISTORY_DATA: _BASE.BASE_URL_V2 + 'historicalResponse', //GETDetail POST PUT DEL
  }

  export const PreopResponse = {
    CRUD_PREOP_RESPONSE_DATA: _BASE.BASE_URL_V2 + 'responseInspections', //POST PUT DEL
    PREOP_RESPONSE_TABLE: _BASE.BASE_URL_V2 + 'responseInspections/table', //GET
  }

  export const PreopResponseType = {
    CRUD_PREOP_TYPE_RESPONSE_DATA: _BASE.BASE_URL_V2 + 'responseType', //POST PUT DEL
    PREOP_TYPE_RESPONSE_TABLE: _BASE.BASE_URL_V2 + 'responseType/table', //GET
    PREOP_TYPE_RESPONSE_COMBO: _BASE.BASE_URL_V2 + 'responseType/combo', //GET
  }

  export const Proyection = {
    PROYECTION_DATA: _BASE.BASE_URL_V2 + 'projections/project', //GET
  }

  export const Indicator = {
    INDICATOR_MAINTENANCE_DATA: _BASE.BASE_URL_V2 + 'indicators/maintenance/detail', //GET
    INDICATOR_MAINTENANCE_TABLE: _BASE.BASE_URL_V2 + 'indicators/maintenance/table', //GET
    INDICATOR_MAINTENANCE_EQUIPMENT: _BASE.BASE_URL_V2 + 'indicators/maintenance/equipment', //GET
    INDICATOR_MAINTENANCE_PORCENT: _BASE.BASE_URL_V2 + 'indicators/maintenance/percentage', //GET
    INDICATOR_MAINTENENCA_NUMBER_ORDER: _BASE.BASE_URL_V2 + 'indicators/maintenance/orders', //GET
    INDICATOR_FUEL_DATA: _BASE.BASE_URL_V2 + 'indicators/fuel/detail', //GET
    INDICATOR_FUEL_TABLE: _BASE.BASE_URL_V2 + 'indicators/fuel/table', //GET
    INDICATOR_FUEL_EQUIPMENT: _BASE.BASE_URL_V2 + 'indicators/fuel/equipment', //GET
    INDICATOR_FUEL_NUMBER_ORDER: _BASE.BASE_URL_V2 + 'indicators/fuel/orders', //GET
    AVERAGE_FUEL_CONSUMPTION: _BASE.BASE_URL_V2 + "indicators/fuel/averageConsumption", // GET
    INDICATOR_DATA_DASHBOARD: _BASE.BASE_URL_V2 + 'indicators/global/data', //GET\
    INDICATOR_INVENTORY_LEVEL_TABLE: _BASE.BASE_URL_V2 + 'indicators/inventory/table/inventoryLevel', //GET\
    INDICATOR_INVENTORY_PENDING_ORDER_TABLE: _BASE.BASE_URL_V2 + 'indicators/inventory/table/ordersReplenishments', //GET\
    INDICATOR_INVENTORY_AVERAGE_TIME_ORDER: _BASE.BASE_URL_V2 + 'indicators/inventory/averageTimeOrders', //GET\
    INDICATOR_INVENTORY_NUMBER_INPUTS: _BASE.BASE_URL_V2 + 'indicators/inventory/numberAnnualInputs', //GET\
    INDICATOR_INVENTORY_NUMBER_OUTPUTS: _BASE.BASE_URL_V2 + 'indicators/inventory/numberAnnualOutputs', //GET\
    INDICATOR_INVENTORY_PURCHASE_ORDER_STATUS: _BASE.BASE_URL_V2 + 'indicators/inventory/purchaseOrderStatus', //GET\
  }

  export const Plans = {
    CRUD_PLANS: _BASE.BASE_URL_V2 + 'plans', //POST PUT DEL GET
    PLANS_TABLE: _BASE.BASE_URL_V2 + 'plans/table', //GET
    PLANS_COMBO: _BASE.BASE_URL_V2 + 'plans/combo', //GET
  }

  export const InventoryInputsHistory = {
    CRUD_INVENT_INPUT_HISTORY_DATA: _BASE.BASE_URL_V2 + 'historicalInputs', //GETDetail POST
    INVENT_INPUT_HISTORY_TABLE: _BASE.BASE_URL_V2 + 'historicalInputs/table', //GET
  }

  export const Item = {
    CRUD_ITEM_DATA: _BASE.BASE_URL_V2 + 'itemInventory', //GETDetail POST PUT
    ITEM_TABLE: _BASE.BASE_URL_V2 + 'itemInventory/table', //GET
    ITEM_COMBO: _BASE.BASE_URL_V2 + 'itemInventory/combo', //GET
    ITEM_COMBO_WAREHOUSE: _BASE.BASE_URL_V2 + 'itemInventory/combo/warehouseAll', //GET
    ITEM_COMBO_OUTPUT_WAREHOUSE: _BASE.BASE_URL_V2 + 'itemInventory/combo/warehouse', //GET
    INACTIVATE_ITEM: Base.BASE_URL_V2 + 'itemInventory/inactivate', //PUT
    ACTIVE_ITEM: Base.BASE_URL_V2 + 'itemInventory/activate', //PUT
  }

  export const Inventory = {
    INVENTORY_TABLE: _BASE.BASE_URL_V2 + 'inventory/table', //GET
    INVENTORY_TABLE_STOCK_MIN: _BASE.BASE_URL_V2 + 'inventory/table/minStock', //GET
    PUT_STOCK_IVENTORY: _BASE.BASE_URL_V2 + 'inventory/stock', //PUT
    PUT_CONST_IVENTORY_EQUIPMENT: _BASE.BASE_URL_V2 + 'equipmentRental/updateCost', //PUT
  }

  export const InventoryOutputsHistory = {
    CRUD_INVENT_OUTPUT_DATA: _BASE.BASE_URL_V2 + 'historicalOutputs', //GETDetail POST
    INVENT_OUTPUT_HISTORY_TABLE: _BASE.BASE_URL_V2 + 'historicalOutputs/table', //GET
  }

  export const PurchaseOrder = {
    CRUD_PURCHASE_ORDER: _BASE.BASE_URL_V2 + 'historicalPurchaseOrder', //GETDetail POST PUT DEL
    PURCHASE_ORDER_TABLE: _BASE.BASE_URL_V2 + 'historicalPurchaseOrder/table', //GETTABLE
    PURCHASE_ORDER_COMBO_STATE: _BASE.BASE_URL_V2 + 'historicalPurchaseOrder/combo/state', //GET
    AUTHORIZE_PURCHASE_ORDER: _BASE.BASE_URL_V2 + 'historicalPurchaseOrder/authorize', //autorizar
    PURCHASE_ORDERs_STATUSES_COMBO: _BASE.BASE_URL_V2 + 'purchaseOrdersStatuses/combo', //GET
    POST_EMAIL: _BASE.BASE_URL_V2 + 'historicalPurchaseOrder/sendEmail', //POST
  }

  export const Warehouse = {
    CRUD_WAREHOUSE: _BASE.BASE_URL_V2 + 'warehouse', //GETDetail POST PUT
    WAREHOUSE_TABLE: _BASE.BASE_URL_V2 + 'warehouse/table', //GETTABLE
    WAREHOUSE_COMBO: _BASE.BASE_URL_V2 + 'warehouse/combo', //GET
    INACTIVATE_WAREHOUSE: Base.BASE_URL_V2 + 'warehouse/inactivate', //PUT
    ACTIVE_WAREHOUSE: Base.BASE_URL_V2 + 'warehouse/activate', //PUT
  }

  export const RentalOrder = {
    CRUD_RENTAL_ORDER: _BASE.BASE_URL_V2 + 'rental', //GETDetail POST PUT DEL
    RENTAL_ORDER_TABLE: _BASE.BASE_URL_V2 + 'rental/table', //GETTABLE
    CRUD_RENTAL_ORDER_REGISTER: _BASE.BASE_URL_V2 + 'rentalRegister', //post get
    STATE_RENTAL_ORDER_COMBO: _BASE.BASE_URL_V2 + 'stateRentalOrder/combo', //GET
    RENTAL_ORDER_COMBO_STATE: _BASE.BASE_URL_V2 + 'rental/combo/state', //GET
  }

  export const EquipmentRental = {
    EQUIPMENT_RENTAL_TABLE: _BASE.BASE_URL_V2 + 'equipmentRental/table', //GETTABLE
    EQUIPMENT_EQUIPMENT_RENTAL_COMBO: _BASE.BASE_URL_V2 + 'equipmentRental/combo', //GET
  }

  export const HistoricalIncomeDispatch = {
    CRUD_HISTORICAL_INCOME_DISPATCH: _BASE.BASE_URL_V2 + 'historicalIncomeDispatch', //GETDetail POST PUT DEL
    HISTORICAL_INCOME_DISPATCH_TABLE: _BASE.BASE_URL_V2 + 'historicalIncomeDispatch/table', //GETTABLE
  }

  export const Module = {
    CRUD_MODULE: _BASE.BASE_URL_V2 + 'modules', //GETDetail,
    MODULE_COMBO: _BASE.BASE_URL_V2 + 'modules/combo'
  }

  export const Security = {
    REFRESH_TOKEN: _BASE.BASE_URL_V2 + 'auth/refreshToken',
    GENERATE_TOKEN: _BASE.BASE_URL_V2 + 'auth/generateToken'
  }

  export const TravelRoute = {
    CRUD_TRAVEL_ROUTER: Base.BASE_URL_V2 + 'travel', //GET Detail POST PUT DEL
    TRAVEL_ROUTER_TABLE: Base.BASE_URL_V2 + 'travel/table', //GETTABLE
    TRAVEL_ROUTER_COMBO: Base.BASE_URL_V2 + 'travel/combo', //GETTABLE
    INACTIVATE_ROUTER: _BASE.BASE_URL_V2 + 'travel/inactivate', //PUST
    ACTIVE_ROUTER: _BASE.BASE_URL_V2 + 'travel/activate', //PUST
  }

  export const Travelhistory = {
    CRUD_TRAVEL_HISTORY: Base.BASE_URL_V2 + 'travelHistory', //GET Detail POST PUT DEL
    TABLE_TRAVEL_HISTORY: Base.BASE_URL_V2 + 'travelHistory/table', //GET
    ADD_POINTER_TRAVEL_HISTORY: Base.BASE_URL_V2 + 'travelHistory/addPointer', //GET
    CLOSE_TRAVEL_HISTORY: Base.BASE_URL_V2 + 'travelHistory/close', //POST
    HAS_TRAVEL_ACTIVE: Base.BASE_URL_V2 + 'travelHistory/hasTravelActive', //GET
    CURRENT_LOCALIZATION: Base.BASE_URL_V2 + 'travelHistory/currentLocationActiveRoute', //GET
    DELETE_CHECKPOINT_TRAVEL: Base.BASE_URL_V2 + 'travelHistory/deleteCheckpoint', //DEL
  }

  export const Traccar = {
    CREATE_SESSION: Base.BASE_URL_V2 + 'auth/createTraccarSession',
    DEVICES: Base.BASE_URL_V2 + 'devices',
    DELETE_DEVICES: Base.BASE_URL_V2 + 'devices/{id}/equipment/{equipmentId}',
    LAST_POSITION_DEVICE: Base.BASE_URL_V2 + 'devices/{id}/position',
  }

    export const Grafana = {
    CREATE_SESSION: Base.BASE_URL_V2 + 'auth/createGrafanaSession',
    GET_DASHBOARD: Base.BASE_URL_V2 + 'grafana/dashboard/{id}',
  }


}
